import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src272999403/src/SleepFront/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src272999403/src/SleepFront/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src272999403/src/SleepFront/src/app/assets/illustration/2 does this sound familiar/webp/cloud.webp");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src272999403/src/SleepFront/src/app/assets/illustration/4 Goodnight, sleep tight/webp/Star.webp");
;
import(/* webpackMode: "eager", webpackExports: ["InstagramSection"] */ "/codebuild/output/src272999403/src/SleepFront/src/app/ui/HomePageVariants/InstagramSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LastCTA"] */ "/codebuild/output/src272999403/src/SleepFront/src/app/ui/HomePageVariants/LastCTA.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PricingSection"] */ "/codebuild/output/src272999403/src/SleepFront/src/app/ui/HomePageVariants/PricingSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SurveyBenefitSection"] */ "/codebuild/output/src272999403/src/SleepFront/src/app/ui/HomePageVariants/SurveyBenefitSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TestimonialsSection"] */ "/codebuild/output/src272999403/src/SleepFront/src/app/ui/HomePageVariants/TestimonialsSection.tsx");
